import { Platform } from 'react-native';
import useMount from 'react-use/lib/useMount';

import { useAppDispatch, useAppStore } from 'store/hooks';
import { SettingActions, SettingSelectors } from 'store/Settings';
import { getMaxGridColunm } from 'util/getMaxGridColumn';

// Offset from the maximum amount that should provide a decent UX.
const COMFORTABLE_AMOUNT_OFFSET = 2;
const MIN_GRID_COLUMN = 1;
// A cap that limits the maximum number of columns set by default on native devices.
// Currently set to 4 as a product decision.
const DEFAULT_GRID_COLUMN_CAP = Platform.select({
  web: Infinity,
  default: 4,
});

export const useSetupMaxGridColum = () => {
  const dispatch = useAppDispatch();

  const store = useAppStore();
  useMount(() => {
    const state = store.getState();
    const allTabColumn =
      SettingSelectors.selectCardViewLayoutAllTabColumn(state);

    const newTabColumn =
      SettingSelectors.selectCardViewLayoutNewTabColumn(state);

    const cookingTabColumn =
      SettingSelectors.selectCardViewLayoutCookingTabColumn(state);

    if (
      allTabColumn === undefined ||
      newTabColumn === undefined ||
      cookingTabColumn === undefined
    ) {
      const { maxGridColumn } = getMaxGridColunm();

      const comfortableGridColumn = Math.max(
        maxGridColumn - COMFORTABLE_AMOUNT_OFFSET,
        MIN_GRID_COLUMN,
      );

      const cappedGridColumn = Math.min(
        comfortableGridColumn,
        DEFAULT_GRID_COLUMN_CAP,
      );

      dispatch(
        SettingActions.setCardViewLayoutNewTabColumn(
          Math.ceil(cappedGridColumn / 2),
        ),
      );
      dispatch(
        SettingActions.setCardViewLayoutCookingTabColumn(
          Math.floor(cappedGridColumn / 2),
        ),
      );

      dispatch(SettingActions.setCardViewLayoutAllTabColumn(cappedGridColumn));
    }
  });
};
